import { useState, useContext } from "react"
import SigmaDefault from "../../components/SigmaDefaulf"
import {
  listAnalytesInEquipment,
  updateAnalytesInEquipment,
  postValueDRM,
  deleteValueDRM,
  updateValueDRM,
  analyteInEquipment,
} from "../../../../../services/sigma"
import { getVariableBiologic } from "../../../../../services/ciq"
import { TableAnalytesInEquipment } from "../../components/TableAnalytesInEquipment"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import intl from "react-intl-universal"
import ModalComponent from "../../../CQIPage/components/ModalComponent"
import { HistoryComponent } from "../../../CQIPage/components/HistoryComponent"
import { fnFormatDateFromUTC, fnFormatedNumber } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"
import { listHistory } from "../../../../../services/ciq"
import { ModalDRM } from "../../components/ModalDRM"
import { ModalTableReference } from "../../components/ModalTableReference"
import { ModalInformation } from "../../../CQIPage/components/ModalInformation"
import { ModalRequiredFieldsActiveSigma } from "../../components/ModalRequiredFieldsActiveSigma"
import { ModalSettings } from "../../components/ModalDeactivateSigma"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import { ModalGo } from "../../components/ModalGo"
import { getWestGardRoles } from "../../../../../services/ciq"
import { updateAnalyteInEquipment } from "../../../../../services/sigma"

export default function ListAnalyesInEquipment() {
  const { id } = useParams()
  const [dataListAnalytes, setDataListAnalytes] = useState([])
  const [loadingInner, setLoadingInner] = useState(false)
  const [analyteSelected, setAnalyteSelected] = useState(null)
  const [biologicalVariable, setBiologicalVariable] = useState([])
  const [updateRequest, setUpdateRequest] = useState(false)
  const [cNameEquipment, setCNameEquipment] = useState("")
  const [bIsHistoryOpenModal, setBIsHistoryOpenModal] = useState(false)
  const [bOpenModalDRM, setBOpenModalDRM] = useState(false)
  const [bOpenModalTableReference, setBOpenModalTableReference] = useState(false)
  const [dataHistory, setDataHistory] = useState([])
  const [isLoadHistory, setIsLoadHistory] = useState(false)
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [per_pageHistory, setPerPageHistory] = useState(1)
  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")
  const [loadingBtnDRM, setLoadingBtnDRM] = useState(false)
  const [loading, setLoading] = useState(false)
  const [update, setUpdate] = useState(false)
  const [modalDelete, setModalDelete] = useState(false)
  const [openModalDeactiveSigma, setOpenModalDeactiveSigma] = useState(false)
  const [openModalInformation, setOpenModalInformation] = useState(false)
  const [openModalGo, setOpenModalGo] = useState(false)
  const [openModalSettings, setModalSettins] = useState(false)
  const [load, setLoad] = useState(false)
  const [rules, setRules] = useState([])
  const [dataAnalyte, setDataAnalyte] = useState({})
  const [isloadingBtn, setIsloadingBtn] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  /*

*/
  const { oUser } = useContext(AuthContext)
  const { isSigma } = useContext(WestgardRulesContext)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const listAnalytes = async () => {
    if (loadingInner) return;
    setLoadingInner(true)
    try {
      const res = await listAnalytesInEquipment(id)

      setDataListAnalytes(
        res.data.data.map((item) => {
          return {
            anlt_biovar_nid: item?.eqpanlt_anlt?.anlt_biovar?.biovar_nid,
            eqp_nid: id,
            anlt_nid: item.eqpanlt_anlt.anlt_nid,
            anlt_cname: item.eqpanlt_anlt.anlt_cname,
            error_total: "",
            drm: item.eqpanlt_drm,
            coef_variation: item?.eqpanlt_covar ? fnFormatedNumber(Number(item.eqpanlt_covar)) : null,
            sigma: item.eqpanlt_sigma,
            power_detection: item.eqpanlt_sigma_detection,
            possibility_rejection: item.eqpanlt_sigma_rejection,
            rule_decision: item.eqpanlt_sigma_rules,
            bSigma: item.eqpanlt_bsigma,
            eqpanlt_nid: item.eqpanlt_nid,
            active: "",
          }
        }),
      )

      setCNameEquipment(res.data.meta.equipment.equipment_cname)
    } catch (err) {
      console.log(err)
    } finally {
      setLoadingInner(false)
    }
  }

  const getBiologicalVariationTable = async () => {
    try {
      const response = await getVariableBiologic()
      setBiologicalVariable(
        response.data.data.map((item) => ({
          label: item.biological_variation_summary,
          value: item.biological_variation_summary,
          id: item.biovar_nid,
        })),
      )
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getBiologicalVariationTable()
  }, [])

  useEffect(() => {
    if (!bOpenModalDRM) {
      listAnalytes()
    }
  }, [bOpenModalDRM])

  useEffect(() => {
    if (!analyteSelected?.bShowSgmaUpdateStatusModal) return
    if (analyteSelected?.bSigma) {
      setOpenModalDeactiveSigma(true)
    } else if (analyteSelected?.bSigma === false) {
      setOpenModalInformation(true)
    }
  }, [analyteSelected])

  useEffect(() => {
    if (!id || !cUserTimeZone || !bIsHistoryOpenModal) return

    getHistoricEquipment(id, per_pageHistory, search_type, text_type)
  }, [id, per_pageHistory, search_type, text_type, cUserTimeZone, update, bIsHistoryOpenModal])

  const updateAnalyte = async (analyteId, biovar_nid, bsigma, rule) => {
    try {
      setLoadingInner(true)
      await updateAnalytesInEquipment(id, analyteId, { biovar_nid, bsigma })
      if (rule === "deactivate") {
        setOpenModalDeactiveSigma(false)
        setOpenModalGo(true)
        await getAnalyteInEquipment(id, analyteSelected.eqpanlt_nid)
        setIsUpdate(false)
        // console.log(res)
        // await rolesWestGard(dataAnalyte)
      }
      await listAnalytes()
    } catch (err) {
      setLoadingInner(false)
      console.log(err)
    } finally {
      setUpdateRequest((oldState) => !oldState)
    }
  }
  const getHistoricEquipment = async (id, perPage, searchType, textType) => {
    if (isLoadHistory) return
    try {
      setDataHistory([])
      setPerPageHistory(1)
      setIsLoadHistory(true)

      const { data: dt } = await listHistory(
        id,
        perPage,
        "search_type=sigma",
        `${textType ? `&${textType?.replace("&", "")}` : ""}`,
        "equipment",
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  const postDRM = async (idEquipment, analyteSelected, value) => {
    try {
      setLoadingBtnDRM(true)
      await postValueDRM(idEquipment, analyteSelected.anlt_nid, Number(value))
      setUpdate((oldState) => !oldState)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingBtnDRM(false)
    }
  }
  const updateDRM = async (idEquipment, iDanalyteSelected, value, idDRM, reason) => {
    try {
      setLoadingBtnDRM(true)
      await updateValueDRM(idEquipment, iDanalyteSelected, value, idDRM, reason)
      setUpdate((oldState) => !oldState)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingBtnDRM(false)
      setModalDelete(false)
    }
  }
  const deleteDRM = async (idEquipment, iDanalyteSelected, idDRM, reason) => {
    try {
      setLoadingBtnDRM(true)
      await deleteValueDRM(idEquipment, iDanalyteSelected, idDRM, reason)
      setUpdate((oldState) => !oldState)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingBtnDRM(false)
      setModalDelete(false)
    }
  }

  const getAnalyteInEquipment = async (idEquipment, eqpAnltId) => {
    try {
      setDataAnalyte(null)
      const response = await analyteInEquipment(idEquipment, eqpAnltId)
      const data = response?.data?.data

      setDataAnalyte(data)
    } catch (err) {
      console.error(err)
    }
  }

  const rolesWestGard = async (dataAnalyte) => {
    if (load) return
    try {
      setLoad(true)

      const response = await getWestGardRoles()
      const newData = response.data.data.map((item) => ({
        eqpanltwgr_wgrdr_nid: item.wgrdr_nid,
        eqpanltwgr_wgrdr_cname: item.wgrdr_cname,
      }))
      localStorage.setItem("dataConfigAnalyte", JSON.stringify(dataAnalyte))

      const analyteWestgardRules = dataAnalyte?.awestgard_rules?.map((item) => ({
        eqpanltwgr_wgrdr_nid: item.eqpanltwgr_wgrdr_nid,
        eqpanltwgr_eaction: item.eqpanltwgr_eaction,
        eqpanltwgr_bstatus: item.eqpanltwgr_bstatus,
      }))

      for (let i = 0; i < analyteWestgardRules?.length; i++) {
        const id = analyteWestgardRules[i].eqpanltwgr_wgrdr_nid
        const match = newData.find((item) => item.eqpanltwgr_wgrdr_nid === id)

        if (!match) {
          analyteWestgardRules[i].eqpanltwgr_wgrdr_cname = "N/A"
        } else {
          analyteWestgardRules[i].eqpanltwgr_wgrdr_cname = match.eqpanltwgr_wgrdr_cname
        }
      }

      setRules(analyteWestgardRules)
    } catch (err) {
      console.error(err)
    } finally {
      setLoad(false)
    }
  }

  const updateSettingsAnalyte = async (data) => {
    try {
      setIsloadingBtn(true)
      await updateAnalyteInEquipment(id, analyteSelected.eqpanlt_nid, data)

      setModalSettins(false)
      await listAnalytes()
      setIsloadingBtn(false)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (openModalSettings && dataAnalyte?.awestgard_rules) {
      rolesWestGard(dataAnalyte)
    }
  }, [dataAnalyte, openModalSettings])

  // useEffect(() => {
  //   if (!analyteSelected) return

  //   getAnalyteInEquipment(id, analyteSelected.eqpanlt_nid)
  // }, [id, analyteSelected?.eqpanlt_nid])

  const handleOnCloseModalHistory = () => {
    setBIsHistoryOpenModal(false)
    setDataHistory([])
    setTextType("")
  }

  return (
    <SigmaDefault
      bArrowLeftGoBack={true}
      cPathGoBack={"/ciq/sigma"}
      cLabelGoBack={`${intl.get("sigma.title")} - ${cNameEquipment}`}
      cText={""}
      bShowBtnTableReference
      cBtnTableReference={intl.get("sigma.btn_table_reference")}
      fnBtnTableReference={() => setBOpenModalTableReference(true)}
      bVisibleIconSearch={false}
      setCSearch={(e) => console.log(e)}
      fnHandleOpenModal={() => setBIsHistoryOpenModal(true)}
    >
      <TableAnalytesInEquipment
        bEdit={false}
        thead={[
          intl.get("sigma.exame_analyte_add_ciq"),
          intl.get("sigma.total_error"),
          intl.get("sigma.drm_result"),
          intl.get("sigma.coef_variation"),
          intl.get("sigma.title"),
          intl.get("sigma.power_detection"),
          intl.get("sigma.possibility_rejection"),
          intl.get("sigma.rule_decision"),
        ]}
        tbodyArray={dataListAnalytes}
        load={!dataListAnalytes.length}
        loadingInnerTable={loadingInner}
        biologicalVariable={biologicalVariable}
        updateAnalyte={updateAnalyte}
        setBOpenModalDRM={setBOpenModalDRM}
        handleCaptureId={(e) => setAnalyteSelected(e)}
      />

      {bIsHistoryOpenModal && (
        <ModalComponent
          title={intl.get("ciq.equipment_history")}
          fnCloseModal={handleOnCloseModalHistory}
          size="xlg"
        >
          <HistoryComponent
            searchHistory="equipment"
            history={dataHistory}
            infoInfinitScroll={infoInfinitScroll}
            setPerPage={setPerPageHistory}
            perPage={per_pageHistory}
            isLoadHistory={isLoadHistory}
            setSearchType={setSearchType}
            setSearchText={setTextType}
          />
        </ModalComponent>
      )}

      {bOpenModalDRM && (
        <ModalDRM
          loading={loading}
          setLoading={setLoading}
          setBOpenModalDRM={setBOpenModalDRM}
          analyteSelected={analyteSelected}
          postDRM={postDRM}
          updateDRM={updateDRM}
          deleteDRM={deleteDRM}
          loadingBtnDRM={loadingBtnDRM}
          update={update}
          modalDelete={modalDelete}
          setModalDelete={setModalDelete}
        />
      )}

      {bOpenModalTableReference && (
        <ModalTableReference setBOpenModalTableReference={setBOpenModalTableReference} />
      )}

      {/* MODAL DE ATIVAR O SIGMA */}
      {openModalInformation && (
        <ModalInformation
          type="submit"
          bgBtn="#1ECB4F"
          title={intl.get("sigma.activate_sigma_exam_analyte")}
          description={intl.get("sigma.activate_sigma", {
            analyte: analyteSelected?.anlt_cname,
          })}
          onCancel={() => setOpenModalInformation(false)}
          onSubmit={() => {
            updateAnalyte(analyteSelected.anlt_nid, analyteSelected.anlt_biovar_nid, true)
            setOpenModalInformation(false)
          }}
        />
      )}

      {/* MODAL DE PREENCHER CAMPOS OBRIGARTÓRIOS PARA ATIVAR O SIGMA */}

      {/* <ModalRequiredFieldsActiveSigma fnRedirect={() => console.log("vai")} /> */}

      {/* MODAL SETTINGS DEACTIVATE */}

      {openModalDeactiveSigma && (
        <ModalInformation
          type="submit"
          isLoad={loadingInner}
          bgBtn="#FF3541"
          title={intl.get("sigma.inactivate_sigma_exam_analyte")}
          description={intl.get("sigma.inactivate_sigma", {
            analyte: analyteSelected?.anlt_cname,
          })}
          onCancel={() => {
            setOpenModalDeactiveSigma(false)
            setAnalyteSelected(null)
          }}
          onSubmit={() => {
            updateAnalyte(
              analyteSelected.anlt_nid,
              analyteSelected.anlt_biovar_nid,
              false,
              "deactivate",
            )
          }}
        />
      )}

      {openModalGo && (
        <ModalGo
          title={intl.get("atention")}
          description={intl.get("sigma.review_rule_westigard")}
          onFirstBtn={() => {
            setOpenModalGo(false)
            setModalSettins(true)
          }}
          titleBtnOne={intl.get("sigma.take_me_there")}
        />
      )}

      {openModalSettings && (
        <ModalSettings
          isloadingBtn={isloadingBtn}
          isLoading={load}
          openModal={setModalSettins}
          dataAnalyte={dataAnalyte}
          rules={rules}
          setRules={setRules}
          fnUpdateAnalyte={updateSettingsAnalyte}
        />
      )}
    </SigmaDefault>
  )
}
